/**
 * Status Badge Component
 * عرض حالة الفاتورة بألوان مميزة
 *
 * Statuses:
 * - draft: مسودة (gray)
 * - pending: قيد الانتظار (yellow)
 * - paid: مدفوعة (green)
 * - cancelled: ملغية (red)
 *
 * Protocols Applied:
 * - P-YNEX-CSS-001: Tailwind CSS Usage
 * - P-YNEX-COMP-002: Component Naming Convention
 */
const StatusBadge = ({ status }) => {
  // Status configuration with Arabic labels and colors
  const statusConfig = {
    draft: {
      label: 'مسودة',
      color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
    },
    pending: {
      label: 'قيد الانتظار',
      color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300'
    },
    paid: {
      label: 'مدفوعة',
      color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
    },
    cancelled: {
      label: 'ملغية',
      color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
    }
  }

  // Get configuration for current status (default to draft)
  const config = statusConfig[status] || statusConfig.draft

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${config.color}`}
    >
      {config.label}
    </span>
  )
}

export default StatusBadge
